import { render, staticRenderFns } from "./ProductPage.htm?vue&type=template&id=b5ff5d5a&scoped=true&external"
import script from "./ProductPage.js?vue&type=script&lang=js&external"
export * from "./ProductPage.js?vue&type=script&lang=js&external"
import style0 from "./ProductPage.scss?vue&type=style&index=0&id=b5ff5d5a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ff5d5a",
  null
  
)

export default component.exports